import { ApiError } from "./error";

export const getErrorMessage = (
  error: unknown,
  defaultMessage: string = "An unexpected error occurred",
): string => {
  if (!error) return defaultMessage;

  // Type assertion for our ApiError structure
  const apiError = error as ApiError;

  // 1. Check for nested error object (User's specific case: { error: { message: ... } })
  if (apiError.response?.data?.error?.message) {
    return apiError.response.data.error.message;
  }

  // 2. Check for top-level message in data (Standard ApiResponse or common REST: { message: ... })
  if (apiError.response?.data?.message) {
    return apiError.response.data.message;
  }

  // 3. Check if response data itself is a string message
  if (typeof apiError.response?.data === "string") {
    return apiError.response.data;
  }

  // 4. Check for standard JS Error message
  if (error instanceof Error) {
    return error.message;
  }

  // 5. Check if error is an object with a message property (generic catch)
  if (typeof error === "object" && error !== null && "message" in error) {
    return (error as { message: string }).message;
  }

  return defaultMessage;
};
